import { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import './JobCard.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import ApplyModal from "../JobsPage/modals/ApplyModal";

export default function JobCard({ jobId, afterRender }) {
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const response = await api.get(`/job_postings/${jobId}`);
        setJob(response.data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchJob();
  }, [jobId]);

  useEffect(() => {
    if (!loading && job && afterRender) {
      afterRender(job);
    }
  }, [loading, job, afterRender]);

  if (loading) {
    return (
      <div className="__job-card">
        Loading...
      </div>
    );
  }

  if (error || !job) {
    return (
      <div className="__job-card">
        Failed to load job.
      </div>
    );
  }

  return (
      <div className='__jobs'>
        <div className='content'>
          <div className='bottom-section'>
            <div className='search-results'>

              <div className='job-card'>
                <div className='job-header'>
                  <a href={`jobs/${job.id}`} rel="noopener noreferrer" target="_blank" className='job-title'>{ job.title }</a>
                </div>
                { job.tags && job.tags.trim() !== '' && (
                  <div className='tags'>
                    { job.tags.split(',').map((tag, idx) => (
                      <div key={ idx } className='tag'>
                        { tag.trim() }
                      </div>
                    )) }
                  </div>
                ) }
                {job.budget !== 0 && job.budget != null && (
                  <div className="budget">
                    Budget: ${job.budget}
                  </div>
                )}
                <div className='body'>
                  { job.summary }
                </div>
                { job.location && (
                  <div className='location'>
                    <FontAwesomeIcon icon={ faLocationDot } /> { job.location }
                  </div>
                ) }
                <div className='apply'>
                  <button className="ppy-btn ppy-btn-primary" onClick={ () => setSelectedJob(job) }>
                    Apply Now
                  </button>
                </div>
                <div className="dates">
                  <div>Posted { new Date(job.created_at).toLocaleDateString('en-US') }</div>
                  { job.expires_at && (
                    <div className="expires-at">
                      <div>Expires { new Date(job.expires_at).toLocaleDateString('en-US') }</div>
                      { new Date(job.expires_at) < new Date() && (
                        <div className="expired">Expired</div>
                      ) }
                    </div>
                  ) }
                </div>
              </div>

            </div>
          </div>
        </div>

        <ApplyModal
          show={ !!selectedJob }
          handleClose={ () => setSelectedJob(null) }
          job={ selectedJob }
        />
      </div>
    );
}
